export default __webpack_public_path__ + "static/media/ls2_g04.32caf4a4.png";